var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-row",style:({
    'height': (_vm.rowsShowMap && _vm.rowsShowMap[_vm.rowId]? _vm.estimatedItemSize * _vm.rowsShowMap[_vm.rowId].rowCount: _vm.estimatedItemSize)  + 'px',
    'top': (_vm.estimatedItemSize * (_vm.rowsShowMap && _vm.rowsShowMap[_vm.rowId]? _vm.rowsShowMap[_vm.rowId].startRow - 1 : -1))  + 'px'
  }),attrs:{"data-rowId":_vm.rowId}})
}
var staticRenderFns = []

export { render, staticRenderFns }